import {Calculator, LayoutList, Scale, Store, UserRound} from 'lucide-react';
import {AccountApp} from '../apps/AccountApp';
import {CompareApp} from '../apps/CompareApp';
import {LoanApp} from '../apps/LoanApp';
import {ManageApp} from '../apps/ManageApp';
import {MarketApp} from '../apps/MarketApp';
import type {AppDefinition} from '../types';

const ICON_SIZE = '56%';

/**
 * The whole product surface, in the order it is meant to be used:
 * find → shortlist → post → afford → account.
 *
 * Adding a module is one entry here plus its view; nothing in `dock/`,
 * `desktop/` or `mobile/` needs to know it exists.
 */
export const APPS: AppDefinition[] = [
  {
    icon: <Store size={ICON_SIZE} strokeWidth={1.6} />,
    id: 'market',
    name: 'Thị trường',
    tint: 'bg-gradient-to-br from-emerald-50 to-emerald-200 text-emerald-800',
    view: MarketApp,
    window: {height: 700, minHeight: 340, minWidth: 380, width: 1180},
  },
  {
    icon: <Scale size={ICON_SIZE} strokeWidth={1.6} />,
    id: 'compare',
    name: 'So sánh',
    tint: 'bg-gradient-to-br from-sky-50 to-sky-200 text-sky-800',
    view: CompareApp,
    window: {height: 660, minHeight: 320, minWidth: 380, width: 1040},
  },
  {
    icon: <LayoutList size={ICON_SIZE} strokeWidth={1.6} />,
    id: 'manage',
    name: 'Quản lý tin đăng',
    shortName: 'Quản lý',
    tint: 'bg-gradient-to-br from-amber-50 to-amber-200 text-amber-800',
    view: ManageApp,
    window: {height: 680, minHeight: 320, minWidth: 380, width: 1020},
  },
  {
    icon: <Calculator size={ICON_SIZE} strokeWidth={1.6} />,
    id: 'loan',
    name: 'Tính vay',
    tint: 'bg-gradient-to-br from-stone-50 to-stone-300 text-stone-700',
    view: LoanApp,
    window: {height: 700, minHeight: 320, minWidth: 380, width: 880},
  },
  {
    icon: <UserRound size={ICON_SIZE} strokeWidth={1.6} />,
    id: 'account',
    name: 'Tài khoản',
    tint: 'bg-gradient-to-br from-violet-50 to-violet-200 text-violet-800',
    view: AccountApp,
    window: {height: 660, minHeight: 320, minWidth: 380, width: 860},
  },
];

export const APP_BY_ID: Record<string, AppDefinition> = Object.fromEntries(
  APPS.map((app) => [app.id, app]),
);

export const DEFAULT_DOCK_ORDER: string[] = APPS.map((app) => app.id);
